import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["atpClusterId", "currentLanguage", "customer", "dialog", "fetchMode", "globalApiUrl", "graphQlUrl", "mode", "productCodes", "shared", "staticApiUrl", "tenant", "token"],
  _excluded2 = ["onClose"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useGetProductInfoDialogProducts } from './useGetProductInfoDialogProducts';
import { useGetProductInfoDialogShowMrpStatement } from './useGetProductInfoDialogShowMrpStatement';
import { DIALOG_MODE_LOADING, DIALOG_MODE_STANDARD_BUY, FETCH_MODE_EAGER, FETCH_MODE_LAZY } from '../constants';
import { ProductInfoDialog } from '../containers';
import { jsx as _jsx } from "react/jsx-runtime";
export var useProductInfoDialog = function useProductInfoDialog(_ref) {
  var atpClusterId = _ref.atpClusterId,
    currentLanguage = _ref.currentLanguage,
    customer = _ref.customer,
    dialog = _ref.dialog,
    _ref$fetchMode = _ref.fetchMode,
    fetchMode = _ref$fetchMode === void 0 ? FETCH_MODE_LAZY : _ref$fetchMode,
    globalApiUrl = _ref.globalApiUrl,
    graphQlUrl = _ref.graphQlUrl,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? DIALOG_MODE_STANDARD_BUY : _ref$mode,
    productCodes = _ref.productCodes,
    shared = _ref.shared,
    staticApiUrl = _ref.staticApiUrl,
    tenant = _ref.tenant,
    token = _ref.token,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = dialog !== null && dialog !== void 0 ? dialog : {},
    onClose = _ref2.onClose,
    dialogProps = _objectWithoutProperties(_ref2, _excluded2);
  var _ref3 = customer !== null && customer !== void 0 ? customer : {},
    customerId = _ref3.customerId;
  var _useGetProductInfoDia = useGetProductInfoDialogProducts({
      atpClusterId: atpClusterId,
      globalApiUrl: globalApiUrl,
      currentLanguage: currentLanguage,
      customerId: customerId,
      graphQlUrl: graphQlUrl,
      productCodes: productCodes,
      tenant: tenant,
      token: token
    }),
    products = _useGetProductInfoDia.data,
    fetchProducts = _useGetProductInfoDia.fetch,
    areProductsLoaded = _useGetProductInfoDia.isLoaded,
    areProductsLoading = _useGetProductInfoDia.isLoading;
  var _useGetProductInfoDia2 = useGetProductInfoDialogShowMrpStatement({
      staticApiUrl: staticApiUrl,
      tenant: tenant
    }),
    showMrpStatement = _useGetProductInfoDia2.data,
    fetchShowMrpStatement = _useGetProductInfoDia2.fetch,
    isShowMrpStatementLoaded = _useGetProductInfoDia2.isLoaded,
    isShowMrpStatementLoading = _useGetProductInfoDia2.isLoading;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var isLoaded = isShowMrpStatementLoaded && areProductsLoaded;
  var isLoading = isShowMrpStatementLoading || areProductsLoading;
  var fetchData = useCallback(function () {
    if (!isLoaded) {
      fetchProducts();
      fetchShowMrpStatement();
    }
  }, [fetchProducts, fetchShowMrpStatement, isLoaded]);
  var close = useCallback(function () {
    setIsOpen(false);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose]);
  var open = useCallback(function () {
    setIsOpen(true);
    if (fetchMode === FETCH_MODE_LAZY) {
      fetchData();
    }
  }, [fetchData, fetchMode]);
  useEffect(function () {
    if (fetchMode === FETCH_MODE_EAGER) {
      fetchData();
    }
  }, [fetchData, fetchMode]);
  useEffect(function () {
    if (isOpen && !areProductsLoading && !areProductsLoaded) {
      // eslint-disable-next-line no-console -- warn about missing data
      console.warn('[PID]: Dialog was closed as GQL returned no product data to display.');
      close();
    }
  }, [areProductsLoaded, areProductsLoading, close, isOpen]);
  return useMemo(function () {
    return {
      closeProductInfoDialog: close,
      isProductInfoDialogOpen: isOpen,
      openProductInfoDialog: open,
      productInfoDialog: /*#__PURE__*/_jsx(ProductInfoDialog, _objectSpread(_objectSpread({}, props), {}, {
        customer: customer,
        dialog: _objectSpread(_objectSpread({}, dialogProps), {}, {
          onClose: close,
          open: isOpen
        }),
        mode: isLoading ? DIALOG_MODE_LOADING : mode,
        products: products,
        shared: _objectSpread(_objectSpread({}, shared), {}, {
          showMrpStatement: showMrpStatement
        })
      }))
    };
  }, [close, customer, dialogProps, isLoading, mode, isOpen, open, products, props, shared, showMrpStatement]);
};